import * as EXIF from 'exif-js'

/**
 * Returns a Promise resolving with the EXIF metadata for Orientation as a code
 * If such a data is not available, returns default code 1
 * See EXIF documentation to interpret the code 
 * (or see : https://www.impulseadventure.com/photo/images/orient_flag.gif)
 * @param image
 */
export function getImageOrientation(image): Promise<number> {
    if (image) {
        return new Promise((resolve, reject) => {
            EXIF.getData(image, function (this: HTMLImageElement) {
                try {
                    const orientation = EXIF.getTag(this, "Orientation")
                    if (orientation) {
                        resolve(orientation)
                    } else {
                        // in the case where no exif tag is present
                        resolve(1)
                    }
                } catch (error) {
                    // in the case where no exif tag is present
                    resolve(1)
                }
            })
            resolve(1)
        })
    }
    return new Promise((resolve, reject) => {
        reject("Error : No image provided")
    })
}